import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';

import usePatch from '@/hooks/usePatch';

import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({
	groupname: yup.string().required('Name is a required field'),
});

export default function Group(props) {
	const { open, onClose, data } = props;

	const isEdit = !!data;

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			groupname: data?.groupname || '',
			groupnumber: data?.groupnumber || '',
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const { mutate: groupAction } = usePatch({
		url: !isEdit ? `groupcategory` : `groupcategory/${data?.id}`,
		method: isEdit ? 'patch' : 'post',
		callback: async (res) => {
			if ([200, 201].includes(res.status) && res.data) {
				toast.success(res.data?.message || `Group ${res.status === 200 ? 'updated' : 'created'} successfully`);
			}
			props.onSave();
			handleClose();
		},
		onError: () => {
			handleClose();
		},
	});

	const onSubmit = (data) => {
		const { groupname, groupnumber } = data;
		let obj = {};
		if (isEdit) {
			obj = { ...data, groupname, groupnumber };
		} else {
			obj = { grouptype: 'P-group', status: 1, groupname, groupnumber };
        }

		groupAction(obj);
		handleClose();
	};
	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-category-group' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[380px]'>
				<span className='text-2xl modal-title'>{isEdit ? `Edit (${data.groupname})` : 'Legg til ny group'}</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					<BaseInputValidation control={control} name='groupname' label='Navn' errors={errors} required />
					<BaseInputValidation control={control} name='groupnumber' label='Nummer' errors={errors} />

					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							{isEdit ? 'Oppdater' : 'Legg til'}
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
